<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Liste des étudiants</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="btn btn-primary"
          to="/ajouter-etudiant"
        >
          <i class="fa fa-plus-circle"></i>
          Ajouter un étudiant
        </router-link>
        <!-- <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Exporter
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un étudiant"
          />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Numero Matricule
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Categorie
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Nom
              </th>
             <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Prénom
              </th>
             
             
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Téléphone 1
              </th>
             <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Email
              </th>
             
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              >ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(etudiant, index) in etudiants" :key="index">
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ etudiant.numeroMatricule }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ etudiant.categorieEtudiant }}
              </td>
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ etudiant.nom }}
              </td>
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ etudiant.prenom }} 
                <span v-if="etudiant?.estTalent" class="badge bg-warning text-dark ms-2">
                  Talent 
                </span>
                <span v-if="etudiant?.user?.firstConnectDate" class="badge bg-info text-white ms-2">
                  <i class="fa fa-pencil me-1"></i> Profil modifié
                </span>
              </td>
              
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ etudiant.telephone1 }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ etudiant.email }}
              </td>
              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0"
              >
               <div class="dropdown">
              <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu dropdown-block" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(267px, 305px);" data-popper-placement="bottom-start">
                    <li 
                      class="dropdown-item d-flex align-items-center"
                      @click.prevent="toggleTalent(etudiant)"
                      style="cursor: pointer"
                    >
                      <i 
                        :class="[
                          'fa',
                          'lh-2',
                          'me-8',
                          'position-relative',
                          'top-1',
                          etudiant.estTalent ? 'fa-star text-secondary' : 'fa-star text-warning'
                        ]"
                      ></i>

                      {{ etudiant.estTalent ? 'Démarquer comme talent' : 'Marquer comme talent' }}
                    </li>
                    <li class="dropdown-item d-flex align-items-center">
                      <router-link :to="{ name: 'EditEtudiantPage', params: { id: etudiant.id } }" 
                          class="dropdown-item d-flex align-items-center"><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>Modifier</router-link>
                    </li>
                    <li class="dropdown-item d-flex align-items-center">
                        <router-link :to="{ name: 'ViewEtudiantPage', params: { id: etudiant.id } }" class="dropdown-item d-flex align-items-center">
                            <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>Détails
                        </router-link>
                    </li>
                    <li class="dropdown-item d-flex align-items-center" >
                      <a
                        class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="suppression(etudiant.id,etudiants,'etudiants',`l\'etudiant ${etudiant.nom} ${etudiant.prenom}`)">
                        <i class="fa fa-trash-o lh-1 me-8 position-relative top-1" ></i>
                         Supprimer
                      </a>
                    </li>
                  </ul>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref} from "vue";
import Swal from "sweetalert2";
import { Etudiant } from "@/models/Etudiant";
import ApiService from "@/services/ApiService";
import { suppression, error } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";

export default defineComponent({
  name: "ListeEtudiant",
  components: {
    PaginationComponent
  },
  setup(){
    
    onMounted(() => {
      getAllEtudiants();
    });

    const etudiants = ref<Array<Etudiant>>([]);   
    const etudiant = ref<Etudiant>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllEtudiants(page_, limit_);
      } catch (error) {
        //
      }
    };

     function rechercher(){
      getAllEtudiants(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getAllEtudiants(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/all/etudiants?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          etudiants.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
      });
    }
    
    function moddifier(Editetudiants:Etudiant) {
      etudiant.value = Editetudiants;
    }

    const deleteEtudiant = (id: number) => {
      ApiService.delete(`/etudiants/${id}`)
      .then(({ data }) => {
        Swal.fire({
          text: data.message,
          toast: true,
          icon: 'success',
          title: 'General Title',
          animation: false,
          position: 'top-right',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          heightAuto: false
        });
      })
      .catch(({ response }) => {
        Swal.fire({
          text: response.data.message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Réssayer à nouveau!",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      });

      for(let i = 0; i < etudiants.value.length; i++) {
        if (etudiants.value[i].id === id) {
          etudiants.value.splice(i, 1);
        }
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const toggleTalent = async (etudiant: any) => {
      if (!etudiant?.id) {
        Swal.fire({
          icon: 'error',
          text: 'Identifiant étudiant invalide',
          heightAuto: false
        })
        return
      }

      const action = etudiant.estTalent ? "démarquer" : "marquer"

      const result = await Swal.fire({
        title: `Voulez-vous ${action} ${etudiant.nom} ${etudiant.prenom} comme talent ?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Oui',
        cancelButtonText: 'Annuler',
        heightAuto: false
      })

      if (!result.isConfirmed) return

      try {
        //  API dynamique selon état
        const url = etudiant.estTalent
          ? `/etudiants/${etudiant.id}/unset-taleitent`
          : `/etudiants/${etudiant.id}/set-talent`

        const { data } = await ApiService.put(`/etudiants/${etudiant.id}/set-talent`, {})
        etudiant.estTalent = data.data.estTalent

        Swal.fire({
          icon: 'success',
          text: data.message || `Action réussie`,
          toast: true,
          position: 'top-right',
          showConfirmButton: false,
          timer: 3000,
          heightAuto: false
        })

        // Mise à jour locale (plus rapide que reload)
        etudiant.estTalent = !etudiant.estTalent
        getAllEtudiants();
      } catch (err: any) {
        Swal.fire({
          icon: 'error',
          text: err.response?.data?.message || "Erreur",
          heightAuto: false
        })
      }
    }
    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    return { etudiants,
      checkPermission,
     getAllEtudiants,
     deleteEtudiant,
     moddifier ,
     suppression,
     page, 
    totalPages,
    limit,
    totalElements,
    handlePaginate,
    rechercher,
    searchTerm,
    toggleTalent
  };
  },
});
</script>